import get from 'lodash/get';

export default (content, { getLinkHrefWithAuthentication }) => ({
  link: getLinkHrefWithAuthentication(get(content, 'link', '')),
  imageURL: get(content, 'media.link.href', ''),
  title: content.title,
  subtitle: content.subtitle,
  alt: content.media.description ?? content.media.filename
});
